import React, { useEffect } from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import Header from './Header';
import Sidebar from '../Sidebar/Sidebar';

const DRAWER_WIDTH = 280;

export default function AppLayout({
  children,
  sidebarOpen,
  onSidebarToggle,
  selectedFolderId,
  onFolderSelect,
  folderTree,
  folderPath,
  search,
  onSearchChange,
  viewMode,
  onViewModeChange,
  onUploadClick,
  onSettingsOpen,
  onAdminSettingsOpen,
  onDashboardOpen,
  onFileDrop,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Chiudi sidebar automaticamente quando si passa a mobile
  useEffect(() => {
    if (isMobile && sidebarOpen) {
      onSidebarToggle(false);
    }
  }, [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <Drawer
        variant={isMobile ? 'temporary' : 'persistent'}
        open={sidebarOpen}
        onClose={() => onSidebarToggle(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: isMobile ? 0 : (sidebarOpen ? DRAWER_WIDTH : 0),
          flexShrink: 0,
          transition: 'width 0.2s ease',
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
          },
        }}
      >
        <Sidebar
          selectedFolderId={selectedFolderId}
          onFolderSelect={(id) => {
            onFolderSelect(id);
            if (isMobile) onSidebarToggle(false);
          }}
          folderTree={folderTree}
          onUploadClick={onUploadClick}
          onFileDrop={onFileDrop}
        />
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          width: '100%',
        }}
      >
        <Header
          sidebarOpen={sidebarOpen}
          onSidebarToggle={() => onSidebarToggle((prev) => !prev)}
          folderPath={folderPath}
          onFolderSelect={onFolderSelect}
          search={search}
          onSearchChange={onSearchChange}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
          onUploadClick={onUploadClick}
          onSettingsOpen={onSettingsOpen}
          onAdminSettingsOpen={onAdminSettingsOpen}
          onDashboardOpen={onDashboardOpen}
        />
        <Box sx={{ flex: 1, p: { xs: 1.5, sm: 2, md: 3 }, overflow: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}
